import React, { useEffect } from 'react'
import { useLocation } from 'react-router';
import ExtendedReportLoan from './components/GeneralInformation/ExtendedReportLoan/ExtendedReportLoan';
import ExtendedReportTcp from './components/GeneralInformation/ExtendedReportTcp/ExtendedReportTcp';
import ExtendedReportIgr from './components/GeneralInformation/ExtendedReportIgr/ExtendedReportIgr';
import FinancialInfo from './components/FinancialInfo/FinancialInfo';
import PerformanceMonitoring from './components/PerformanceMonitoring/PerformanceMonitoring';
import ProjectMilestones from './components/ProjectMilestones/ProjectMilestones';
import EarlyWarnings from './components/EarlyWarnings/EarlyWarnings';
import Agreements from './components/Agreements/Agreements';
import EnviromentalSafeguards from './components/EnviromentalSafeguards/EnviromentalSafeguards';

const DownloadReport = () => {
    const { state } = useLocation<any>();
    const data = state?.data;
    const order: string[] = state?.order || [];
    const generalInfo = data?.sectionOnePortfolio;
    const isLoan = data?.isLoan;
    const isTcp = data?.isTcp;
    const isIgr = data?.isIgr;
    const creationDate = data?.creationDate;
    const regions = data?.regions;
    const myPortfolio = data?.myPortfolio;
    const countries = data?.countries;


    const componentsBySection: Record<string, JSX.Element | null> = {
        'loan-info': data?.sectionOnePortfolio?.loan
            ? <ExtendedReportLoan
                data={data.sectionOnePortfolio.loan}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
                isPdfExport={true}
            />
            : null,

        'tcp-info': data?.sectionOnePortfolio?.tcp
            ? <ExtendedReportTcp
                data={data.sectionOnePortfolio.tcp}
                creationDate={creationDate}
                regions={regions}
                myPortfolio={myPortfolio}
                countries={countries}
                isPdfExport={true}
            />
            : null,

        'igr-info': data?.sectionOnePortfolio?.igr
            ? <ExtendedReportIgr
                data={data.sectionOnePortfolio.igr}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
                isPdfExport={true}
            />
            : null,

        'financial-info': data?.sectionTwoFinantialInformation
            ? <FinancialInfo
                data={data.sectionTwoFinantialInformation}
                isLoan={isLoan}
                isTcp={isTcp}
                isIgr={isIgr}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
            />
            : null,

        'performance-monitoring': data?.sectionThreePerformanceMonitoring
            ? <PerformanceMonitoring
                data={data.sectionThreePerformanceMonitoring}
                isLoan={isLoan}
                isTcp={isTcp}
                isIgr={isIgr}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
            />
            : null,

        'project-milestones': data?.sectionFourProjectLifeCycleMilestones
            ? <ProjectMilestones
                data={data.sectionFourProjectLifeCycleMilestones}
                isLoan={isLoan}
                isTcp={isTcp}
                isIgr={isIgr}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
            />
            : null,

        'early-warnings': data?.sectionFiveEarlyWarningsGCMAlerts
            ? <EarlyWarnings
                data={data.sectionFiveEarlyWarningsGCMAlerts}
                isLoan={isLoan}
                isTcp={isTcp}
                isIgr={isIgr}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
            />
            : null,

        'agreements': data?.sectionSixAccordances
            ? <Agreements
                data={data.sectionSixAccordances}
                isLoan={isLoan}
                isTcp={isTcp}
                isIgr={isIgr}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
            />
            : null,

        'enviromental-safeguards': data?.sectionSevenEnvironmentSocialSafe
            ? <EnviromentalSafeguards
                data={data.sectionSevenEnvironmentSocialSafe}
                isLoan={isLoan}
                isTcp={isTcp}
                isIgr={isIgr}
                creationDate={creationDate}
                regions={regions}
                countries={countries}
                myPortfolio={myPortfolio}
            />
            : null
    };

    return (
        <div>
            <h2>Vista previa a descargar</h2>
            <div>
                {order.map((sectionId, index) => {
                    if (sectionId === 'general-info') {
                        return (
                            <React.Fragment key={`general-info-${index}`}>
                                {isLoan && generalInfo?.loan && (
                                    <div style={{ pageBreakAfter: 'always' }} key="loan-info">
                                        <ExtendedReportLoan
                                            data={generalInfo.loan}
                                            creationDate={creationDate}
                                            regions={regions}
                                            countries={countries}
                                            myPortfolio={myPortfolio}
                                            isPdfExport={true}
                                        />
                                    </div>
                                )}
                                {isTcp && generalInfo?.tcp && (
                                    <div style={{ pageBreakAfter: 'always' }} key="tcp-info">
                                        <ExtendedReportTcp
                                            data={generalInfo.tcp}
                                            creationDate={creationDate}
                                            regions={regions}
                                            countries={countries}
                                            myPortfolio={myPortfolio}
                                            isPdfExport={true}
                                        />
                                    </div>
                                )}
                                {isIgr && generalInfo?.igr && (
                                    <div style={{ pageBreakAfter: 'always' }} key="igr-info">
                                        <ExtendedReportIgr
                                            data={generalInfo.igr}
                                            creationDate={creationDate}
                                            regions={regions}
                                            countries={countries}
                                            myPortfolio={myPortfolio}
                                            isPdfExport={true}
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    }

                    const component = componentsBySection[sectionId];
                    return component ? (
                        <div key={sectionId + index} style={{ pageBreakAfter: 'always' }}>
                            {component}
                        </div>
                    ) : null;
                })}
            </div>
        </div>
    );

}

export default DownloadReport